<template>
  <div>
    <div
      v-if="errors"
      class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.correctErrors") }}</strong>
      </p>
    </div>
    <div v-if="comment_requests.length != 0">
      <div class="flex flex-col pb-4">
        <div class="flex flex-col shadow-md bg-gray-100 mb-1 pt-0 p-3">
          <div class="p-2">
            <div class="flex justify-between">
              <h2
                v-for="cat in requestForm.categories"
                :key="cat.sort_order"
                class="text-red text-lg text-bold capitalize mt-2 pb-4 pt-2 border-red-light ml-0"
              >{{ $t("requests.remarques")}}</h2>
              <div class="flex items-center w-auto bg-white pb-4 mr-0 mt-3">
                <sp-button
                  theme="outline-blue"
                  space="small"
                  type="submit"
                  class="justify-end rounded mx-0 add-comment-btn"
                  @click="showModal()"
                >
                  <i class="fas fa-comment-dots"></i>
                  {{ $t("form.write_comment")}}
                </sp-button>
              </div>
            </div>

            <div v-for="(comment_request,index) in comment_requests" :key="index">
              <ul class="comments-timeline">
                <li>
                  <time class="comment-time">
                    <span>{{new Date(comment_request.created_at)| dateFormat('DD/MM/YYYY HH:mm')}}</span>
                  </time>
                  <div class="comment-icon">
                    <div v-if="comment_request.user_id === candidat.id">
                      <i class="icon-message icon-message-candidat fas fa-comment-dots"></i>
                    </div>
                    <div v-else>
                      <i class="icon-message icon-message-responsible fas fa-comment-dots"></i>
                    </div>
                  </div>
                  <div class="flex-wrap comment-content">
                    <div class="flex">
                      <h4 v-if="comment_request.user_id === candidat.id">{{comment_request.last_name}} {{comment_request.name }} &nbsp;</h4>
                      <h4 v-else>{{ $t("team.team_startupact")}} &nbsp;</h4>
                      <p>{{ $t("form.added_comment")}} &nbsp;</p>
                    </div>
                    <blockquote>
                      <p class="blockquote blockquote-primary" v-html="comment_request.content"></p>
                    </blockquote>
                    <div v-if="comment_request.document_id">
                      <a :href="comment_request.path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    <div v-else>
                      <div v-if="comment_request.document_path">
                      <a :href="comment_request.document_path" download target="_blank">{{ $t("requests.download_file") }}</a>
                    </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="comment_requests.length == 0"
      class="flex items-center justify-end w-auto bg-white mx-0"
    >
      <sp-button
        theme="outline-blue"
        space="small"
        type="submit"
        class="justify-end rounded add-comment-btn"
        @click="showModal()"
      >
        <i class="fas fa-comment-dots"></i>
        {{ $t("form.write_comment")}}
      </sp-button>
    </div>

    <!-- Modal add comment request -->
    <commentRequest @add-comment="onClickCommentRequest" />

    <form autocomplete="off" name="formrequest" v-on:submit.prevent="requestFormUpdate()">
      <div v-for="cat in requestForm.categories" :key="cat.sort_order">
        <h2
          class="text-red text-lg text-bold mb-5 capitalize pb-2 py-6 border-red-light border-b"
        >Modification de la {{cat.name}}</h2>
        <div v-for="(q, index) in responses_questions" :key="index">
          <div v-if="q.category_id != null && q.category_id === cat.id">
            <div v-if="type == $t('requests.request_stop_leave')">
                 <q-form
                  :question="q"
                  :started="true"
                  @update-disabled="updateDisabled"
                  :showError="showError"
                  :requestFormEdit="true"
                  @governorate="governoratechange"
                  :delegation="delegation"
                  :responses="responses"
                  :labelDate="session.startup_application.label_created_at"
                  :requestId="advRequests.id"
                  :startLeaveDate="advRequests.startLeaveDate"
                ></q-form>
            </div>
             <div v-else-if="type == $t('requests.request_stop_bourse')">
                 <q-form
                  :question="q"
                  :started="true"
                  @update-disabled="updateDisabled"
                  :showError="showError"
                  :requestFormEdit="true"
                  @governorate="governoratechange"
                  :delegation="delegation"
                  :responses="responses"
                  :labelDate="session.startup_application.label_created_at"
                  :requestId="advRequests.id"
                  :startBourseDate="advRequests.startBourseDate"
                  :endBourseDate="advRequests.endBourseDate"
                ></q-form>
            </div> 
            <div v-else>
              <q-form
                :question="q"
                :started="true"
                @update-disabled="updateDisabled"
                :showError="showError"
                :requestFormEdit="true"
                @governorate="governoratechange"
                :delegation="delegation"
                :responses="responses"
                :labelDate="session.startup_application.label_created_at"
                :requestId="advRequests.id"
              ></q-form>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="advRequests.status != 2"
        class="flex items-center justify-end w-auto bg-white mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button theme="outline-blue" space="small" type="submit">{{ $t("form.send")}}</sp-button>
      </div>
    </form>
  </div>
</template>



<script>
import ApiService from "@/common/api.service";
import { REQUEST_FORM_GET, 
REQUEST_FORM_UPDATE,
PRELABEL_FORM_UPDATE
} from "@/store/actions.type";
import { mapGetters, mapState } from "vuex";
import ButtonVue from "../../components/spKit/Button.vue";
import QForm from "@/components/Candidat/QForm.vue";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp,
  SET_REQUEST_FORM,
  SET_ERROR
} from "@/store/mutations.type";
import commentRequest from "../Label/commentRequest.vue";
export default {
  name: "fromrequest",
  components: {
    "sp-button": ButtonVue,
    commentRequest: commentRequest,
    "q-form": QForm
  },

  data() {
    return {
      questions: null,
      startupRequest: null,
      content: null,
      inProgress: false,
      isSubmitted: false,
      showError: false,
      responses: [],
      responses_questions: [],
      comment_requests: [],
      advRequests: [],
      type: null,
      delegation: null,
      hash: ''
    };
  },
  mounted() {
    this.$store.commit(SET_LabelMenuActive, 1);
    this.$store.commit(SET_ApplicationMenuActive, 0);
    this.$store.commit(SET_HashId, this.session.startup_application.id);
    this.$store.commit(SET_LabelApp, this.$route.params.code_label);
    this.id = this.$route.params.id;
    this.code_label = this.$route.params.code_label;
    this.request_id = this.$route.params.request_id;
    this.showStartupRequestByDetail(this.code_label, this.id, this.request_id);
    if (this.$route.params.code_label) {
      this.$Progress.start();
      this.$store
        .dispatch(REQUEST_FORM_GET, {
          label: this.$route.params.code_label,
          type_id: this.$route.params.id,
          request_id: this.$route.params.request_id
        })
        .then(data => {
          this.$store.commit(SET_HashId, data.data.application.id);
          this.$Progress.finish();
        });
    }
  },
  created () {
    this.id = this.$route.params.id;
    this.code_label = this.$route.params.code_label;
    this.request_id = this.$route.params.request_id;
    this.showStartupRequestByDetail(this.code_label, this.id, this.request_id);
    if (this.$route.params.code_label) {
      this.$Progress.start();
      this.$store
        .dispatch(REQUEST_FORM_GET, {
          label: this.$route.params.code_label,
          type_id: this.$route.params.id,
          request_id: this.$route.params.request_id
        })
        .then(data => {
         
          this.$store.commit(SET_HashId, data.data.application.id);
          this.$Progress.finish();
        });
    }
  }, 
  methods: {
    onClickCommentRequest(comment) {
      var comment_candidat = {
        content: comment[0],
        created_at: new Date(),
        last_name: this.session.user_auth.last_name,
        name: this.session.user_auth.name,
        ref_id: this.advRequests.id,
        user_id: this.session.user_auth.id,
        document_path: comment[1]
      };
      this.comment_requests.unshift(comment_candidat);
    },
    governoratechange(data) {
      this.delegation = data;
    },
    updateDisabled(val) {
      this.inProgress = val;
      this.isSubmitted = val;
    },
    requestFormUpdate() {
      this.$Progress.start();
      let form = this.getForm();
      this.isSubmitted = false;
      if (this.hash) {
        this.$store
          .dispatch(PRELABEL_FORM_UPDATE, form)
          .then(data => {
            this.responses = [];
            this.isSubmitted = true;
            this.inProgress = false;
            this.showError = false;
            this.$router.push({
                name: "Label",
                params: {
                  app_id: this.hashId
                }
              });
          })
          .catch(error => {
            this.responses_questions = this.requestForm.questions;
            this.showError = true;
            this.inProgress = false;
          });
      } else {
        this.$store
          .dispatch(REQUEST_FORM_UPDATE, form)
          .then(() => {
            this.responses = [];
            this.isSubmitted = true;
            this.inProgress = false;
            this.showError = false;
            if (form.label) {
              this.$router.push({
                name: parseInt(this.$route.params.id) === 11 ? "Financement" : "Avantages",
                params: {
                  app_id: this.hashId
                }
              });
            } else {
              this.$router.push({
                name: "Label",
                params: {
                  app_id: this.hashId
                }
              });
            }
          })
          .catch(() => {
            this.responses_questions = this.requestForm.questions;
            this.inProgress = false;
            this.showError = true;
          });
      }
      window.scrollTo(0, 0);

      this.$Progress.finish();
    },
    getForm() {
      this.inProgress = true;
      let finalResponses = [];
      Array.prototype.forEach.call(this.responses, final => {
        if (final.content != "") {
          finalResponses.push(final);
        }
      });
      let form = {
        label: this.$route.params.code_label,
        type_id: this.$route.params.id,
        request_id: this.$route.params.request_id,
        responses: finalResponses
      };
      return form;
    },
    showStartupRequestByDetail(code_label, id, request_id) {
      this.code_label = this.$route.params.code_label;
      this.id = this.$route.params.id;
      this.request_id = this.$route.params.request_id;
      this.hash = this.$route.params.appHash;
      if (this.hash) {
        ApiService.get(
          `/api/request/get-request/${id}`
        )
          .then(data => {
            this.responses_questions = data.data.data.form.questions;
            this.comment_requests = data.data.data.advRequest.comments;
            this.advRequests = data.data.data.advRequest;
            this.candidat = data.data.data.user;
            this.type = data.data.data.type;
            this.$store.commit(SET_REQUEST_FORM, data.data.data);
          })
          .catch((response) => {
            this.$router.push({ name: "home" });
          });
      } else if (parseInt(this.$route.params.id) === 11 ){
        ApiService.get(
        `/api/request/show-detail/${code_label}/${id}/${request_id}`
      )
        .then(data => {
          if (Object.keys(data.data.data).length === 0) {
            this.$router.push({
              path: "/financement",
              params: {
                app_id: this.hashId
              }
            });
          } else {
            this.responses_questions = data.data.data.form.questions;
            this.comment_requests = data.data.data.advRequest.comments;
            this.advRequests = data.data.data.advRequest;
            this.candidat = data.data.data.user;
        
          }
        })
        .catch(() => {
          this.$router.push({ name: "home" });
        });
      } else {
        ApiService.get(
        `/api/request/show-detail/${code_label}/${id}/${request_id}`
      )
        .then(data => {
          if (Object.keys(data.data.data).length === 0) {
            this.$router.push({
              path: "/avantages",
              params: {
                app_id: this.hashId
              }
            });
          } else {
            this.responses_questions = data.data.data.form.questions;
            this.comment_requests = data.data.data.advRequest.comments;
            this.advRequests = data.data.data.advRequest;
            this.candidat = data.data.data.user;
            this.type = data.data.data.type;
          }
        })
        .catch(() => {
          this.$router.push({ name: "home" });
        });
      }
      
    },
    showModal() {
      this.$modal.show("comment-request");
    }
  },
  computed: {
    ...mapGetters([
      "session",
      "requestForm",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication"
    ]),
    ...mapState({
      errors: state => state.session.errors
    })
  }
};
</script>


<style scoped>
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 40%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card.container {
  padding: 2px 16px;
}

.bg-doc {
  background-repeat: no-repeat;
  background-size: 50px 49px;
  height: 50px;
  width: 50px;
}
.border {
  border-color: #cad2e2;
}
.chip {
  padding: 0 15px;
  height: 30px;
  font-size: 16px;
  line-height: 30px;
  border-radius: 25px;
}

@import "../../assets/css/style_comments.scss";
</style>
